<template lang="pug">
  .save-info-2-element
    b-card.mb-0.card-inactive.p-2(no-body)
      fieldset(:disabled="disabled")
        b-form-row.align-items-center.justify-content-end(v-if="!disabled")
          b-col
            span.text-sm.text-success(v-if="isNew") Nuevo
          b-col(cols="auto")
            x-icon.icon-md.hover-danger.pointer.text-secondary(@click="$emit('destroy', element_id)")
        b-form-row.align-items-end
          b-col
            b-form-group(label="Variable:", v-for="(e_a, e_a_index) in Element_Attributes", :key="e_a.element_attribute_id", v-if="e_a.name == 'user_attribute_id'", :id="`element_attribute_${e_a.element_attribute_id}`")
              k-select.disabled-white(
                placeholder="- Seleccionar variable -",
                :options="parsedUserAttributes",
                :disabled="disabled",
                :value="e_a.value || null",
                @input="updateElementAttribute(e_a, $event)"
              )
          b-col
            b-form-group(label="Nuevo valor:", v-for="(e_a, e_a_index) in Element_Attributes", :key="e_a.element_attribute_id", v-if="e_a.name == 'user_attribute_value'", :id="`element_attribute_${e_a.element_attribute_id}`")
              vue-tribute(:options="tributeOpts")
                b-form-input.disabled-white(
                  placeholder="Nuevo valor",
                  :value="e_a.value",
                  @blur="updateElementAttribute(e_a, $event)"
                )
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import templateElementCommon from '@/helpers/template-element-common'
import Select from '@/components/Select.vue'
import _debounce from 'lodash.debounce'

const accountController = createNamespacedHelpers('account')

export default {
  mixins: [templateElementCommon],
  computed: {
    ...accountController.mapState({
      user_attributes: state => state.user_attributes
    }),
    parsedUserAttributes () {
      return this.user_attributes.map(a => {
        return {
          label: a.name,
          id: a.user_attribute_id
        }
      })
    }
  },
  components: {
    'k-select': Select
  },
  created () {
    this.updateElementAttribute = _debounce((element_attribute, value) => {
      const attribute = JSON.parse(JSON.stringify(element_attribute))

      if (value && value.target) {
        attribute.value = value.target._value
      } else {
        attribute.value = value
      }

      this.updateAttribute(this.block_id, this.template_id, this.element_id, attribute)

      this.$message.success('Actualizado')
    }, 100, { leading: false, trailing: true })
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .save-info-2-element {

    &:not(:last-child) {
      margin-bottom: 1rem;
    }
  }
</style>
